import React from 'react';
import lazyGettext from 'js-utils/lazy-gettext';

import ScreenSmallSvg from 'eventbrite_design_system/iconography/icons/ScreenSmall';
import LockSvg from 'eventbrite_design_system/iconography/icons/Lock';
import MegaphoneSvg from 'eventbrite_design_system/iconography/icons/Megaphone';
import EyeSvg from 'eventbrite_design_system/iconography/icons/Eye';
import CalendarRepeatSvg from 'eventbrite_design_system/iconography/icons/CalendarRepeat';
import StopwatchSvg from 'eventbrite_design_system/iconography/icons/Stopwatch';
import CreditCardBackSvg from 'eventbrite_design_system/iconography/icons/CreditCardBack';
import TicketSvg from 'eventbrite_design_system/iconography/icons/Ticket';
import ScanCheckSvg from 'eventbrite_design_system/iconography/icons/ScanCheck';
import ReceiptSvg from 'eventbrite_design_system/iconography/icons/Receipt';
import FriendsSvg from 'eventbrite_design_system/iconography/icons/Friends';
import MoneySvg from 'eventbrite_design_system/iconography/icons/Money';
import LineChartSvg from 'eventbrite_design_system/iconography/icons/LineChart';
import TrophySvg from 'eventbrite_design_system/iconography/icons/Trophy';
import DocumentSvg from 'eventbrite_design_system/iconography/icons/Document';
import GlobeSvg from 'eventbrite_design_system/iconography/icons/Globe';
import ScreenLargeSvg from 'eventbrite_design_system/iconography/icons/ScreenLarge';
import CartSvg from 'eventbrite_design_system/iconography/icons/Cart';
import RowSvg from 'eventbrite_design_system/iconography/icons/Row';
import StarSvg from 'eventbrite_design_system/iconography/icons/Star';
import WifiSvg from 'eventbrite_design_system/iconography/icons/Wifi';
import LifePreserverSvg from 'eventbrite_design_system/iconography/icons/LifePreserver';
import HeadphoneSvg from 'eventbrite_design_system/iconography/icons/Headphone';
import BookSvg from 'eventbrite_design_system/iconography/icons/Book';
import BriefcaseSvg from 'eventbrite_design_system/iconography/icons/Briefcase';
import GearSvg from 'eventbrite_design_system/iconography/icons/Gear';
import UserSvg from 'eventbrite_design_system/iconography/icons/User';
import PhotoSvg from 'eventbrite_design_system/iconography/icons/Photo';
import CardReaderSvg from 'eventbrite_design_system/iconography/icons/CardReader';
import DownloadSvg from 'eventbrite_design_system/iconography/icons/Download';
import ChatSvg from 'eventbrite_design_system/iconography/icons/Chat';

export const MOBILE_OPTIMIZED = {
    heading: lazyGettext('Mobile-optimized event page'),
    description: lazyGettext(
        'Easily create a professional-looking, 100% mobile-optimize event page that looks great on any device.',
    ),
    iconType: <ScreenSmallSvg />,
};

export const SECURE_PAYMENTS = {
    heading: lazyGettext('Secure payments'),
    description: lazyGettext(
        "Accept credit and debit cards without a merchant account using Eventbrite's PCI-compliant payment processor, and pass your fees to attendees.",
    ),
    iconType: <LockSvg />,
};

export const PROMOTIONAL_TOOLS = {
    heading: lazyGettext('Free promotional tools'),
    description: lazyGettext(
        'Promote your event with free tools like custom email invitations, integrated Facebook promotion, and built-in social sharing.',
    ),
    iconType: <MegaphoneSvg />,
};

export const SALES_TRACKING = {
    heading: lazyGettext('Sales at your fingertips'),
    description: lazyGettext(
        "Track sales, counts, and basic attendee info in real-time from any device, so you always know who's coming.",
    ),
    iconType: <EyeSvg />,
};

export const MULTIPLE_EVENTS = {
    heading: lazyGettext('Many events in one'),
    description: lazyGettext(
        'Sell tickets to a series of recurring events — like classes or workshops — on a single event page, so you can efficiently promote and manage your events.',
    ),
    iconType: <CalendarRepeatSvg />,
};

export const INTEGRATIONS_A = {
    heading: lazyGettext('Time-saving integrations'),
    description: lazyGettext(
        "Save time with our seamless integrations with over 170+ tools you already use, like Facebook, Mailchimp, and Raiser's Edge.",
    ),
    iconType: <StopwatchSvg />,
};

export const INTEGRATIONS_B = {
    heading: lazyGettext('Time-saving integrations'),
    description: lazyGettext(
        'Eliminate manual tasks by seamlessly integrating Eventbrite with 170+ tools you already use, like Salesforce, Mailchimp, and SurveyMonkey.',
    ),
    iconType: <StopwatchSvg />,
};

export const INTEGRATIONS_C = {
    heading: lazyGettext('Save time with integrations'),
    description: lazyGettext(
        "Eliminate manual tasks by seamlessly integrating Eventbrite with online and on-site tools like Salesforce, Raiser's Edge, and Marcato — or create your own with our open API.",
    ),
    iconType: <StopwatchSvg />,
};

export const SIMPLE_CHECKOUT = {
    heading: lazyGettext('Simple, secure checkout'),
    description: lazyGettext(
        'Delight your guests with a simple mobile-friendly purchase flow they already trust — no user account, captcha, or login required.',
    ),
    iconType: <CreditCardBackSvg />,
};

export const DIGITAL_TICKETS = {
    heading: lazyGettext('Digital tickets'),
    description: lazyGettext(
        'Let attendees access their tickets from the Eventbrite app, Passbook, Apple Watch, or their email.',
    ),
    iconType: <TicketSvg />,
};

export const ONE_TICKET_TYPE = {
    heading: lazyGettext('One ticket type'),
    description: lazyGettext(
        'Sell a single type of ticket (for example, "General Admission") at a single price point, for all your attendees.',
    ),
    iconType: <TicketSvg />,
};

export const FAST_CHECKIN = {
    heading: lazyGettext('Rapid check-in'),
    description: lazyGettext(
        'Use the Eventbrite Organizer app to impress attendees with rapid check-in and ticket sales at the door.',
    ),
    iconType: <ScanCheckSvg />,
};

export const BASIC_TICKETING = {
    heading: lazyGettext('Basic ticketing and registration'),
    description: lazyGettext(
        'Create a professional-looking, 100% mobile-optimized event page to collect payment and basic attendee info.',
    ),
    iconType: <ReceiptSvg />,
};

export const SEAMLESS_CHECKIN = {
    heading: lazyGettext('Seamless check-in'),
    description: lazyGettext(
        'Get your attendees in quickly with seamless check-in or at-the-door sales from any device, using our Organizer app',
    ),
    iconType: <ScanCheckSvg />,
};

export const MARKETPLACE = {
    heading: lazyGettext('Reach new audiences'),
    description: lazyGettext(
        'Reach a wider audience and drive sales through our partner sites like Facebook and Spotify.',
    ),
    iconType: <FriendsSvg />,
};

export const HIGH_CONVERSION = {
    heading: lazyGettext('4X the conversion'),
    description: lazyGettext(
        'Allow event-goers to purchase tickets wherever they discover your event — converting interest into ticket sales at 4X the average e-commerce rate.',
    ),
    iconType: <MoneySvg />,
};

export const CUSTOM_TICKET_OPTIONS = {
    heading: lazyGettext('Customizable ticket options'),
    description: lazyGettext(
        'Create multiple tickets at different prices to attract a wider variety of attendees',
    ),
    iconType: <TicketSvg />,
};

export const REPORTING_ESSENTIALS = {
    heading: lazyGettext('Reporting essentials'),
    description: lazyGettext(
        'Easily view total sales and RSVPs from any device, and export your detailed order and attendee data.',
    ),
    iconType: <LineChartSvg />,
};

export const DETAILED_ANALYTICS_A = {
    heading: lazyGettext('Detailed analytics'),
    description: lazyGettext(
        'Optimize your marketing with customizable real-time data views on mobile and desktop.',
    ),
    iconType: <LineChartSvg />,
};

export const DETAILED_ANALYTICS_B = {
    heading: lazyGettext('Hone your marketing'),
    description: lazyGettext(
        'Take control of your ticket sales with 24/7 access to real-time data and custom analytics from any device.',
    ),
    iconType: <TrophySvg />,
};

export const DETAILED_ANALYTICS_C = {
    heading: lazyGettext('Detailed sales analytics'),
    description: lazyGettext(
        'Easily generate actionable insights by ticket type and across multiple events, so you can optimize your marketing.',
    ),
    iconType: <LineChartSvg />,
};

export const MARKETING_TOOLS = {
    heading: lazyGettext('Powerful marketing tools'),
    description: lazyGettext(
        'Extend your marketing with targeted event promotion tools like email marketing, social promotion, and industry-leading SEO.',
    ),
    iconType: <MegaphoneSvg />,
};

export const PAYOUTS_A = {
    heading: lazyGettext('Payouts on your schedule'),
    description: lazyGettext(
        'Get paid fast to keep your business liquid, with scheduled payouts before your event.',
    ),
    iconType: <MoneySvg />,
};

export const PAYOUTS_B = {
    heading: lazyGettext('Payouts before your event'),
    description: lazyGettext(
        'Apply to get paid weekly or biweekly so you can pay vendors and keep your business liquid.',
    ),
    iconType: <MoneySvg />,
    paypalExcl: true,
};

export const PAYOUTS_C = {
    heading: lazyGettext('Get paid on your schedule'),
    description: lazyGettext(
        'Get paid before your event to improve your cash flows and keep vendors in good standing.',
    ),
    iconType: <MoneySvg />,
};

export const INSTALLMENT_PAYMENTS = {
    heading: lazyGettext('Installment payments'),
    description: lazyGettext(
        'Increase sales of high-priced tickets by letting buyers pay in monthly installments, at no risk to you.',
    ),
    iconType: <MoneySvg />,
};

export const CUSTOM_REGISTRATION = {
    heading: lazyGettext('Customizable registration forms'),
    description: lazyGettext(
        'Learn what you need to about your attendees when they purchase — and avoid surprises on event day.',
    ),
    iconType: <DocumentSvg />,
};

export const DISTRIBUTION_A = {
    heading: lazyGettext('Reach new audiences'),
    description: lazyGettext(
        'Reach a wider audience and drive sales through our partner sites like Facebook and Spotify.',
    ),
    iconType: <GlobeSvg />,
};

export const DISTRIBUTION_B = {
    heading: lazyGettext('Sell where your fans are'),
    description: lazyGettext(
        'Let buyers purchase tickets wherever they discover your event — from your website to Eventbrite to Facebook.',
    ),
    iconType: <GlobeSvg />,
};

export const PARTNER_SITES = {
    heading: lazyGettext('Listing on Eventbrite and partner sites'),
    description: lazyGettext(
        'Reach a wider audience and drive sales through our partner sites like Facebook and Spotify.',
    ),
    iconType: <ScreenLargeSvg />,
};

export const CHECKOUT_WIDGET_A = {
    heading: lazyGettext('Sales on your site'),
    description: lazyGettext(
        'Convert hard-earned traffic into sales with our website integrations that make it easy to sell wherever your fans are.',
    ),
    iconType: <CartSvg />,
};

export const CHECKOUT_WIDGET_B = {
    heading: lazyGettext('Ticket sales on your own site'),
    description: lazyGettext(
        'Convert more interest into ticket buyers by allowing attendees to purchase from your website.',
    ),
    iconType: <CartSvg />,
    paypalExcl: true,
};

export const CHECKOUT_WIDGET_C = {
    heading: lazyGettext('Make purchases easy'),
    description: lazyGettext(
        'Avoid purchase frustrations with our streamlined, mobile-friendly flow your attendees already know and trust — no user account, captcha, or login required.',
    ),
    iconType: <CreditCardBackSvg />,
};

export const CHECKOUT_WIDGET_D = {
    heading: lazyGettext(
        'Simple, secure checkout on Eventbrite or your website',
    ),
    description: lazyGettext(
        'Avoid purchase frustrations with our streamlined, mobile-friendly flow your attendees already know and trust — no user account, captcha, or login required.',
    ),
    iconType: <CreditCardBackSvg />,
};

export const RESERVED_SEATING = {
    heading: lazyGettext('Reserved seating'),
    description: lazyGettext(
        'Maximize your revenue by creating a map of your venue and charging higher prices for better seats.',
    ),
    iconType: <RowSvg />,
    paypalExcl: true,
};

export const UNLIMITED_TICKET_TYPES = {
    heading: lazyGettext('Unlimited ticket types'),
    description: lazyGettext(
        'Create multiple tickets at different prices and attract a wider variety of attendees.',
    ),
    iconType: <TicketSvg />,
};

export const VIP_EXPERIENCES_A = {
    heading: lazyGettext('Memorable experiences'),
    description: lazyGettext(
        'Create VIP experiences for your most valued guests with custom registration forms, diverse ticket options, reserved seating, and mobile guest lists.',
    ),
    iconType: <StarSvg />,
};

export const VIP_EXPERIENCES_B = {
    heading: lazyGettext('Delight attendees onsite'),
    description: lazyGettext(
        'Shorten lines and create VIP experience with Organizer app mobile box office, reserved seating, and RFID access control cashless payments that keep working without power or internet',
    ),
    iconType: <StarSvg />,
};

export const RFID_TECHNOLOGY = {
    heading: lazyGettext('RFID technology'),
    description: lazyGettext(
        'Use RFID technology to speed up lines for big crowds at your box office, gates, and on-site vendors.',
    ),
    iconType: <WifiSvg />,
};

export const ORGANIZER_MOBILE_APP = {
    heading: lazyGettext('Organizer mobile app'),
    description: lazyGettext(
        'Track ticket sales, scan tickets and check-in guests from any iOS or Android device.',
    ),
    iconType: <ScreenSmallSvg />,
};

export const ONLINE_HELP_CENTER = {
    heading: lazyGettext('Online Help Center'),
    description: lazyGettext(
        'Access product "how to\'s" and answers to frequently asked questions in our Help Center.',
    ),
    iconType: <LifePreserverSvg />,
};

export const TRAINING_AND_SUPPORT_A = {
    heading: lazyGettext('Training and support'),
    description: lazyGettext(
        'Get the training and support you need with customized onboarding, 24/7 phone support, and access to a Customer Success Manager.',
    ),
    iconType: <HeadphoneSvg />,
};

export const TRAINING_AND_SUPPORT_B = {
    heading: lazyGettext('Product training'),
    description: lazyGettext(
        'Save time learning the ins and outs of Eventbrite, and ensure you maximize the impact of the platform on your goals.',
    ),
    iconType: <BookSvg />,
};

export const CUSTOMER_SUCCESS_MANGER_SUPPORT = {
    heading: lazyGettext('Customer Success Manager'),
    description: lazyGettext(
        'Get ongoing, personalized support to help you use Eventbrite in the way that best achieves your goals.',
    ),
    iconType: <HeadphoneSvg />,
};

export const ONSITE_SUPPORT = {
    heading: lazyGettext('On-site staffing and support'),
    description: lazyGettext(
        'Improve your day-of operations with pre-event consultation, on-site technical support, and even full event staffing.',
    ),
    iconType: <BriefcaseSvg />,
};

export const PHONE_24_7_SUPPORT = {
    heading: lazyGettext('24/7 phone support'),
    description: lazyGettext(
        "Rest assured you'll be able to reach a human for support, no matter what time of day or night.",
    ),
    iconType: <HeadphoneSvg />,
};

export const GENERAL_SUPPORT = {
    heading: lazyGettext(
        'Phone, chat, and email support for event creators with paid events',
    ),
    description: lazyGettext(
        'Get questions answered quickly by talking to a human during business hours (8am-6:30pm CST).',
    ),
    iconType: <HeadphoneSvg />,
};

export const GENERAL_SUPPORT_HK_SG_NZ = {
    heading: lazyGettext(
        'Phone, chat, and email support for event creators with paid events',
    ),
    description: lazyGettext(
        'Get questions answered quickly by talking to a human during business hours (8am-5:30pm AEDT).',
    ),
    iconType: <HeadphoneSvg />,
};

export const SERVICES_AND_STAFFING = {
    heading: lazyGettext('Services and staffing'),
    description: lazyGettext(
        'Tap into on-site operations support, box office and gate staffing, and custom design services to knock your event out of the park.',
    ),
    iconType: <FriendsSvg />,
};

export const RELIABLE_ONSALES = {
    heading: lazyGettext('Reliable onsales'),
    description: lazyGettext(
        'Rely on our 99.99% site uptime to ensure your fans can get tickets during high-demand onsales.',
    ),
    iconType: <GearSvg />,
};

export const TEAM_PERMISSIONS_A = {
    heading: lazyGettext('Set team access levels'),
    description: lazyGettext(
        'Set your team up with the right permissions, so everyone is equipped to play their role.',
    ),
    iconType: <UserSvg />,
};

export const TEAM_PERMISSIONS_B = {
    heading: lazyGettext('Team access and permissions'),
    description: lazyGettext(
        'Work more efficiently across your team, while keeping the right information in the right hands.',
    ),
    iconType: <FriendsSvg />,
};

export const WHITE_LABELING_A = {
    heading: lazyGettext('Put your brand front and center'),
    description: lazyGettext(
        'Sell on your website or on new custom community pages to show attendees a fully branded experience.',
    ),
    iconType: <PhotoSvg />,
};

export const WHITE_LABELING_B = {
    heading: lazyGettext('Branded community pages'),
    description: lazyGettext(
        'Put your brand front and center with a community landing page and custom branded event templates.',
    ),
    iconType: <PhotoSvg />,
};

export const RENT_EQUIPMENT = {
    heading: lazyGettext('Rental equipment for box office and entry'),
    description: lazyGettext(
        'Shorten lines with battle-tested, enterprise-grade tech at your box office, registration table, and gates.',
    ),
    iconType: <CardReaderSvg />,
};

export const INCLUDE_ESSENTIALS = {
    heading: lazyGettext('Everything in Essentials'),
    description: lazyGettext(
        'Nail the basics with a 100% mobile-optimized event page, a mobile app, and distribution on partner sites.',
    ),
    iconType: <DownloadSvg />,
};

export const INCLUDE_ESSENTIALS_WITH_EPP = {
    ...INCLUDE_ESSENTIALS,
    description: lazyGettext(
        'Nail the basics with a 100% mobile-optimised event page, trusted payment processing, a mobile app, and distribution on partner sites',
    ),
};

export const INCLUDE_PROFESSIONAL = {
    heading: lazyGettext('Everything in Professional'),
    description: lazyGettext(
        'Grow your event with a flexible, mobile-optimized event page, an integration to sell on your website, and detailed analytics.',
    ),
    iconType: <DownloadSvg />,
};

export const PACKAGE_ONE_FEATURES = [
    lazyGettext('One ticket type (ex. "General Admission")'),
    lazyGettext('Ticketing & registration essentials'),
    lazyGettext('Organizer mobile app'),
    lazyGettext('Listing on Eventbrite and partner sites'),
    lazyGettext('Online Help Center'),
];

export const PACKAGE_ONE_FEATURES_AU_V2 = [
    lazyGettext('Unlimited ticket types'),
    lazyGettext('Ticketing & registration essentials'),
    lazyGettext('Organiser mobile app'),
    lazyGettext('Listing on Eventbrite and partner sites'),
    lazyGettext('Online Help Center'),
];

export const PACKAGE_ONE_FEATURES_UK = [
    lazyGettext('Ticket fees include payment processing'),
    lazyGettext('Sell tickets directly through Facebook'),
    lazyGettext('One ticket type (e.g. "General Admission")'),
    lazyGettext('Mobile app for organisers'),
    lazyGettext('Listing on Eventbrite and partner sites'),
    lazyGettext('Access to a range of partner apps (e.g. Mailchimp)'),
    lazyGettext('Online help centre'),
];

export const PACKAGE_TWO_FEATURES_UK = [
    lazyGettext('Everything in Essentials'),
    lazyGettext('Embedded checkout on your website'),
    lazyGettext('Unlimited ticket types'),
    lazyGettext('Detailed sales analytics and reporting'),
    lazyGettext('Customisable checkout forms'),
    //  lazyGettext('Payouts before your event'),
    lazyGettext('Create seating maps'),
    lazyGettext('Phone & email support for event creators with paid events'),
];

export const PACKAGE_THREE_FEATURES_UK = [
    lazyGettext('Everything in Professional'),
    lazyGettext('Choose your service level'),
    lazyGettext('Product training'),
    lazyGettext('Rental equipment for box office and entry'),
    lazyGettext('Personal Account Manager'),
    lazyGettext('On-site support'),
    lazyGettext('Customised payouts'),
    lazyGettext('RFID - Entry system'),
    lazyGettext('24/7 phone & email support'),
];

export const PACKAGE_TWO_FEATURES = [
    lazyGettext('Everything in Essentials, plus:'),
    lazyGettext('Unlimited ticket types'),
    lazyGettext('Ticket sales on your own site'),
    lazyGettext('Customizable checkout forms'),
    lazyGettext('Detailed sales analytics'),
    lazyGettext('Reserved seating'),
    lazyGettext(
        'Phone, chat, and email support for event creators with paid events',
    ),
];

export const PACKAGE_TWO_FEATURES_AU = [
    lazyGettext('Everything in Essentials, plus:'),
    lazyGettext('Ticket sales on Facebook'),
    lazyGettext('Ticket sales on your own site'),
    lazyGettext('Customizable checkout forms'),
    lazyGettext('Detailed sales analytics'),
    lazyGettext('Reserved seating'),
    lazyGettext(
        'Phone, chat, and email support for event creators with paid events',
    ),
];

export const PACKAGE_TWO_FEATURES_FOR_CL_CO_PE = [
    lazyGettext('Everything in Essentials, plus:'),
    lazyGettext('Unlimited ticket types'),
    lazyGettext('Ticket sales on your own site'),
    lazyGettext('Customizable checkout forms'),
    lazyGettext('Detailed sales analytics'),
    lazyGettext('Chat, and email support for event creators with paid events'),
];

export const PACKAGE_TWO_FEATURES_FOR_DK_NO_SE = [
    lazyGettext('Everything in Essentials, plus:'),
    lazyGettext('Unlimited ticket types'),
    lazyGettext('Customizable checkout forms'),
    lazyGettext('Detailed sales analytics'),
    //  lazyGettext('Payouts before your event'),
    lazyGettext(
        'Phone, chat, and email support for event creators with paid events',
    ),
];

export const PACKAGE_TWO_FEATURES_ALL = [
    lazyGettext('Everything in Essentials, plus:'),
    lazyGettext('Unlimited ticket types'),
    lazyGettext('Ticket sales on your own site'),
    lazyGettext('Customizable checkout forms'),
    lazyGettext('Detailed sales analytics'),
    //  lazyGettext('Payouts before your event'),
    lazyGettext('Reserved seating'),
    lazyGettext(
        'Phone, chat, and email support for event creators with paid events',
    ),
];

export const PACKAGE_TWO_FEATURES_CH = [
    lazyGettext('Everything in Essentials, plus:'),
    lazyGettext('Unlimited ticket types'),
    lazyGettext('Customizable checkout forms'),
    lazyGettext('Detailed sales analytics'),
    //  lazyGettext('Payouts before your event'),
    lazyGettext(
        'Phone, chat, and email support for event creators with paid events',
    ),
];

export const PACKAGE_ONE_FEATURES_MARKETPLACE_B = [
    lazyGettext('One ticket type (ex. "General Admission")'),
    lazyGettext('Ticketing & registration essentials'),
    lazyGettext('Organizer mobile app'),
    lazyGettext('Online Help Center'),
];

export const PACKAGE_TWO_FEATURES_MARKETPLACE_B = [
    lazyGettext('Everything in Essentials, plus:'),
    lazyGettext('Unlimited ticket types'),
    lazyGettext('Public listing on Eventbrite'),
    lazyGettext('Distribution to partner sites'),
    lazyGettext('Ticket sales on your own site'),
    lazyGettext('Customizable checkout forms'),
    lazyGettext('Detailed sales analytics'),
    lazyGettext('Reserved seating'),
    lazyGettext('Phone, chat, and email support'),
];

export const PACKAGE_ONE_GERMAN_FEATURES = [
    lazyGettext('Includes payment transaction for every payment method'),
    lazyGettext('Sell tickets directly through Facebook'),
    lazyGettext('One ticket type (e.g. “Early bird”)'),
    lazyGettext('Mobile app for organizers'),
    lazyGettext('Listing on Eventbrite and partner sites'),
    lazyGettext('Access to a range of partner apps'),
    lazyGettext('Online help center'),
];

export const PACKAGE_TWO_GERMAN_FEATURES = [
    lazyGettext('Everything in Essentials'),
    lazyGettext('Embedded checkout on your website'),
    lazyGettext('Unlimited ticket types'),
    lazyGettext('Detailed sales analytics'),
    lazyGettext('Customisable checkout forms'),
    //  lazyGettext('Payouts before your event'),
    lazyGettext('Reserved seating'),
    lazyGettext('Phone and email support for event creators with paid events'),
];

export const PACKAGE_THREE_GERMAN_FEATURES = [
    lazyGettext('Everything in Professional'),
    lazyGettext('Choose your service level'),
    lazyGettext('Product training'),
    lazyGettext('Rental equipment for box office and entry'),
    lazyGettext('Personal Account Manager'),
    lazyGettext('On-site support'),
    lazyGettext('Customized payouts'),
    lazyGettext('RFID - Entry system'),
    lazyGettext('24/7 phone & email support'),
];

export const EVERYTHING_IN_PROFESSIONAL = lazyGettext(
    'Everything in Professional, plus:',
);
export const TEAM_ACCESS = lazyGettext('Team access and permissions');
export const RENTAL_EQUIPMENT = lazyGettext(
    'Rental equipment for box office and entry',
);
export const ON_SITE_STAFFING = lazyGettext('On-site staffing and support');
export const BRAND_PAGES = lazyGettext('Branded community pages');
export const INSTALLMENT = lazyGettext('Installment payments');
export const PRODUCT_TRAINING = lazyGettext('Product training');
export const PHONE_SUPPORT = lazyGettext('24/7 phone support');
export const CUSTOMER_SUCCESS_MANGER = lazyGettext('Customer Success Manager');

export const PACKAGE_THREE_FEATURES = [
    EVERYTHING_IN_PROFESSIONAL,
    TEAM_ACCESS,
    RENTAL_EQUIPMENT,
    ON_SITE_STAFFING,
    BRAND_PAGES,
    PRODUCT_TRAINING,
    PHONE_SUPPORT,
    CUSTOMER_SUCCESS_MANGER,
];

export const PACKAGE_THREE_FEATURES_CH = [
    EVERYTHING_IN_PROFESSIONAL,
    TEAM_ACCESS,
    BRAND_PAGES,
    PRODUCT_TRAINING,
    PHONE_SUPPORT,
    CUSTOMER_SUCCESS_MANGER,
];

export const CUSTOMER_SUPPORT = {
    featureHeading: lazyGettext(
        'Customer Support phone, chat, and email support for all events',
    ),
    iconType: <ChatSvg />,
};
